import React, { useState, useEffect } from 'react';
import { api } from '../services/api';
import { Download, FileSpreadsheet, ArrowUpDown, ChevronUp, ChevronDown } from 'lucide-react';
import { useSortableData } from '../hooks/useSortableData';

const Exports = () => {
    const [exportedFiles, setExportedFiles] = useState([]);
    const [loadingExports, setLoadingExports] = useState(true);

    const { items: sortedFiles, requestSort, sortConfig } = useSortableData(exportedFiles);
    const getSortIcon = (key) => {
        if (!sortConfig || sortConfig.key !== key) return <ArrowUpDown size={14} style={{ display: 'inline', marginLeft: '4px', opacity: 0.3 }} />;
        return sortConfig.direction === 'ascending' ? <ChevronUp size={14} style={{ display: 'inline', marginLeft: '4px', color: 'var(--primary)' }} /> : <ChevronDown size={14} style={{ display: 'inline', marginLeft: '4px', color: 'var(--primary)' }} />;
    };

    useEffect(() => {
        const fetchExports = async () => {
            try {
                const res = await api.inventory.getExportedFiles().catch(() => null);
                if (res?.data) {
                    setExportedFiles(res.data || []);
                }
            } catch (error) {
                console.error("Exports Error", error);
            } finally {
                setLoadingExports(false);
            }
        };

        fetchExports();
    }, []);

    return (
        <div>
            <div className="page-header" style={{ marginBottom: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                    <h1>Raw Exports</h1>
                    <p>Automated EOD CSV Snapshots and other generated reports.</p>
                </div>
            </div>

            <div className="card" style={{ marginBottom: '2rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
                    <h2 className="card-title" style={{ marginBottom: 0 }}>Available Raw Exports</h2>
                    <span style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>Automated EOD CSV Snapshots</span>
                </div>
                {loadingExports ? (
                    <p>Loading exports...</p>
                ) : exportedFiles.length === 0 ? (
                    <p style={{ color: 'var(--text-muted)' }}>No CSV snapshots exported yet.</p>
                ) : (
                    <div className="table-container">
                        <table>
                            <thead>
                                <tr>
                                    <th className="sortable" onClick={() => requestSort('filename')}>Filename {getSortIcon('filename')}</th>
                                    <th className="sortable" onClick={() => requestSort('createdAt')}>Exported At {getSortIcon('createdAt')}</th>
                                    <th className="sortable" onClick={() => requestSort('sizeBytes')}>Size {getSortIcon('sizeBytes')}</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sortedFiles.map((file, idx) => (
                                    <tr key={`${file.filename}-${idx}`}>
                                        <td style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontWeight: 500, color: 'var(--text-main)' }} title={file.filename}>
                                            <FileSpreadsheet size={16} color="var(--primary)" />
                                            {file.filename}
                                        </td>
                                        <td>{new Date(file.createdAt).toLocaleString()}</td>
                                        <td>{(file.sizeBytes / 1024).toFixed(1)} KB</td>
                                        <td>
                                            <a
                                                href={api.inventory.downloadFileUrl(file.filename)}
                                                download={file.filename}
                                                style={{
                                                    display: 'inline-flex', alignItems: 'center', gap: '0.3rem',
                                                    padding: '0.4rem 0.8rem', backgroundColor: '#f1f5f9',
                                                    color: 'var(--text-main)', borderRadius: '4px',
                                                    textDecoration: 'none', fontSize: '0.85rem', fontWeight: 500
                                                }}
                                            >
                                                <Download size={14} /> Download CSV
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Exports;
